<template>
  <!--
    Kompakte Anzeige des Gesprächsverhaltens in den Telefonlisten
    (Kundenfeedback 09.10.2026). Die Ergänzung steht im Tooltip.
  -->
  <v-tooltip v-if="visible" :text="tooltip" location="top" max-width="320">
    <template #activator="{ props: activator }">
      <span
        v-bind="activator"
        class="cbc"
        role="note"
        :aria-label="tooltip"
        tabindex="0"
      >
        <v-chip
          v-for="o in items"
          :key="o.key"
          :color="colorOf(o)"
          :prepend-icon="o.icon"
          :class="['cbc__chip', `cbc__chip--${o.tone}`]"
          size="x-small"
          variant="tonal"
          label
        >{{ $gt(o.label) }}</v-chip>
        <v-icon v-if="noteText" class="cbc__note-icon" size="14" icon="mdi-comment-text-outline" />
      </span>
    </template>
  </v-tooltip>
</template>

<script>
import {
  contactBehaviorColor,
  contactBehaviorOptions,
  describeContactBehavior,
  normalizeContactBehaviorNote,
} from "@/utils/contactBehavior";

export default {
  name: "ContactBehaviorChips",
  props: {
    /** Schlüssel des Gesprächsverhaltens. */
    behavior: { type: Array, default: () => [] },
    note: { type: String, default: null },
  },
  computed: {
    items() {
      return contactBehaviorOptions(this.behavior);
    },
    noteText() {
      return normalizeContactBehaviorNote(this.note);
    },
    visible() {
      return this.items.length > 0 || this.noteText !== null;
    },
    tooltip() {
      const text = describeContactBehavior(this.behavior, this.note, (s) => this.$gt(s));
      return `${this.$gt('Gesprächsverhalten')}: ${text}`;
    },
  },
  methods: {
    colorOf(o) {
      return contactBehaviorColor(o.tone);
    },
  },
};
</script>

<style scoped>
.cbc { display: inline-flex; flex-wrap: wrap; align-items: center; gap: 4px; outline: none; }
.cbc:focus-visible { outline: 2px solid var(--primary-color, #2563eb); outline-offset: 2px; border-radius: 4px; }
.cbc__chip { font-weight: 600; letter-spacing: 0.01em; }
.cbc__note-icon { color: #64748b; }
</style>
